// Country code configuration with phone number lengths
export interface CountryConfig {
  code: string;
  name: string;
  phoneLength: number; // Length of phone number without country code
  format?: (phone: string) => string;
}

export const countries: CountryConfig[] = [
  { code: '+1', name: 'United States', phoneLength: 10, format: (phone) => {
    if (phone.length === 0) return '';
    if (phone.length <= 3) return `(${phone}`;
    if (phone.length <= 6) return `(${phone.slice(0, 3)}) ${phone.slice(3)}`;
    return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
  }},
  { code: '+44', name: 'United Kingdom', phoneLength: 10 },
  { code: '+91', name: 'India', phoneLength: 10 },
  { code: '+86', name: 'China', phoneLength: 11 },
  { code: '+81', name: 'Japan', phoneLength: 10 },
  { code: '+49', name: 'Germany', phoneLength: 11 },
  { code: '+33', name: 'France', phoneLength: 9 },
  { code: '+61', name: 'Australia', phoneLength: 9 },
  { code: '+55', name: 'Brazil', phoneLength: 11 },
  { code: '+52', name: 'Mexico', phoneLength: 10 },
  { code: '+971', name: 'UAE', phoneLength: 9 },
  { code: '+966', name: 'Saudi Arabia', phoneLength: 9 },
  { code: '+65', name: 'Singapore', phoneLength: 8 },
  { code: '+60', name: 'Malaysia', phoneLength: 9 },
  { code: '+62', name: 'Indonesia', phoneLength: 9 },
];

export const getCountryByCode = (code: string): CountryConfig | undefined => {
  return countries.find(country => country.code === code);
};

export const getDefaultCountry = (): CountryConfig => {
  return countries[0]; // Default to US
};

export const validatePhoneNumber = (phone: string, countryCode: string): boolean => {
  const country = getCountryByCode(countryCode);
  if (!country) return false;
  
  const digitsOnly = phone.replace(/\D/g, '');
  return digitsOnly.length === country.phoneLength;
};

export const formatPhoneNumber = (phone: string, countryCode: string): string => {
  const country = getCountryByCode(countryCode);
  if (!country || !country.format) {
    // Default formatting if no custom format
    return phone;
  }
  return country.format(phone);
};

